import { createAction } from 'redux-actions';

export const setCurrentRep = createAction('SET_CURRENT_REPRESENTATIVE', rep => ({ rep }));
export const paginate = createAction('PAGINATE_REPRESENTATIVE', activePage => ({ activePage }));
export const setActivePage = createAction('SET_REPS_ACTIVE_PAGE', activePage => ({ activePage }));
export const setQuery = createAction('SET_REPS_QUERY', query => ({ query }));

export const getReps = createAction('GET_REPRESENTATIVES', query => ({ query }));
export const getRepsSuccess = createAction('GET_REPRESENTATIVES_SUCCESS', (reps, count) => ({ reps, count }));
export const getRepsFail = createAction('GET_REPRESENTATIVES_FAIL', error => ({ error }));

export const getRepsForFirm = createAction('GET_REPRESENTATIVES_FOR_FIRM', firmId => ({ firmId }));
export const getRepsForFirmSuccess = createAction('GET_REPRESENTATIVES_FOR_FIRM_SUCCESS', reps => ({
  reps,
}));
export const getRepsForFirmFail = createAction('GET_REPRESENTATIVES_FOR_FIRM_FAIL', error => ({ error }));

export const getRepById = createAction('GET_REPRESENTATIVE_BY_ID', id => ({ id }));
export const getRepByIdSuccess = createAction('GET_REPRESENTATIVE_BY_ID_SUCCESS', rep => ({ rep }));
export const getRepByIdFail = createAction('GET_REPRESENTATIVE_BY_ID_FAIL', error => ({ error }));

export const addRep = createAction('ADD_REPRESENTATIVE', rep => ({ rep }));
export const addRepSuccess = createAction('ADD_REPRESENTATIVE_SUCCESS', rep => ({ rep }));
export const addRepFail = createAction('ADD_REPRESENTATIVE_FAIL', error => ({ error }));

export const updateRep = createAction('UPDATE_REPRESENTATIVE', rep => ({ rep }));
export const updateRepSuccess = createAction('UPDATE_REPRESENTATIVE_SUCCESS', rep => ({ rep }));
export const updateRepFail = createAction('UPDATE_REPRESENTATIVE_FAIL', error => ({ error }));
